import React from 'react';
import AppForm from 'components/Form/AppForm/AppForm'
import { addressInfoForm } from 'FormDefinitions/AddressInfoForm/AddressInfoFormDefinition'
import useAppFormLogic from 'components/Form/AppForm/hooks/useAppFormLogic'


/**
 * Strona formularza zbierająca informację o adresie zamieszkania
*/
const AddressInfoForm = (): JSX.Element => {

   const { handleAddressInfoFormSubmitButtonClick } = useAppFormLogic({ form: addressInfoForm })

   return ( <AppForm form={addressInfoForm} handleSubmitButtonClick={(e: React.SyntheticEvent) => handleAddressInfoFormSubmitButtonClick(e)} /> )
}

export default AddressInfoForm